import React from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import { memoizeGetAutoGeneratedColorForLabels } from '@atlassian/jira-option-color-picker/src/option-color-generator/index.tsx';
import { getColorMetadata } from '@atlassian/jira-option-color-picker/src/color-picker/utils/index.tsx';
import type { ColoredLabel } from '@atlassian/jira-issue-shared-types/src/common/types/labels-type.tsx';
import { useColoredLabelsStore } from '@atlassian/jira-option-color-picker/src/colored-labels-store/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useLabelsStore } from '../../../services/field/colored-labels/index.tsx';
import type { JsonComponentProps } from '../../../model/fields/types.tsx';
import Tags from '../common/tags/index.tsx';

type Props = JsonComponentProps<'labels'>;

const getLabelColor = (label: ColoredLabel) => {
	const colorName = label.color;

	const { backgroundColor: color } = getColorMetadata(
		colorName || memoizeGetAutoGeneratedColorForLabels(label.name),
	);
	return color;
};

const Labels = ({ tableInjectedProps: { isLastColumn }, dataSelectorProps: { value } }: Props) => {
	if (
		expVal(
			'adding-color-to-labels-field-experiment-milestone2',
			'isColorfulNewLabelsEnabled',
			false,
		)
	) {
		const [{ coloredLabelSuggestions }] = fg('change_import_path_for_usecoloredlabelsstore')
			? // eslint-disable-next-line react-hooks/react-compiler
				// eslint-disable-next-line react-hooks/rules-of-hooks
				useColoredLabelsStore()
			: // eslint-disable-next-line react-hooks/react-compiler
				// eslint-disable-next-line react-hooks/rules-of-hooks
				useLabelsStore();

		const coloredLabels = coloredLabelSuggestions?.labels;
		const coloredValue = value.map((val) => {
			const labelWithColor = coloredLabels.find((label) => label.name === val.name);

			const labelColor = labelWithColor && getLabelColor(labelWithColor);

			return {
				...val,
				...{ color: labelColor },
			};
		});

		return (
			<Tags
				// @ts-expect-error - ts2322 -  Property 'href' is optional in type '{ color: string | undefined; name: string; href?: string | undefined; }' but required in type 'TagData'.
				tags={coloredValue}
				isLastColumn={isLastColumn}
				{...(expVal(
					'adding-color-to-labels-field-in-jira-experiment',
					'isColoredLabelsEnabled',
					false,
				)
					? { isColored: true }
					: {})}
			/>
		);
	}

	return (
		<Tags
			// @ts-expect-error - TS2322 - Type 'LabelsProps' is not assignable to type 'TagData[]'.
			tags={value}
			isLastColumn={isLastColumn}
			{...(expVal(
				'adding-color-to-labels-field-in-jira-experiment',
				'isColoredLabelsEnabled',
				false,
			)
				? { isColored: true }
				: {})}
		/>
	);
};

export default Labels;
